import Container from 'typedi';
import { PostLoginActionNameEnum } from '@sparkware/uc-sdk-core';

import UserApi from '../../../../APIs/UserApi';
import { StorageItemEnum } from '../../../models/enums/storage-enums';
import { SessionSimpleStoreService } from '../../storage/implementations/simple-store';
import { UIService } from '../../ui';
import {
    ICheckIfLoginNotificationRequiredPostLoginOptions,
    IPostLoginActionsState,
} from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';
import { ToastType } from '../../../models/enums/general-enums';

export class OpenLoginNotificationPostLoginAction extends PostLoginActionBase {
    private readonly _uiService: UIService;
    private readonly _sessionSimpleStoreService: SessionSimpleStoreService;

    constructor(state: IPostLoginActionsState) {
        super(
            PostLoginActionNameEnum.CheckIfLoginNotificationRequired,
            'OpenLoginNotificationPostLoginAction',
            state,
        );

        this._uiService = Container.get(UIService);
        this._sessionSimpleStoreService = Container.get(SessionSimpleStoreService);
    }

    protected override canExecute = (
        options?: ICheckIfLoginNotificationRequiredPostLoginOptions,
    ): Promise<boolean> => {
        const isLoginNotificationEnabledInSessionStorage =
            this._sessionSimpleStoreService.get(StorageItemEnum.LoginNotification) !== undefined;
        const canExecute = isLoginNotificationEnabledInSessionStorage && options?.enabled;

        return Promise.resolve(canExecute);
    };

    protected override doAction = async (): Promise<boolean> => {
        const { response, errorResponse } = await UserApi.RegulationLoginMessage();
        if (response) {
            const toastOptions = { template: ToastType.RegulationLogin };
            this._uiService.showToast(toastOptions, response);
        } else {
            this._logger.error(`execute: error:`, errorResponse);
        }
        this.completeAction();
        return false;
    };
}
